import { FC } from 'react'

import { FormProvider, useForm } from 'react-hook-form'
import * as R from 'remeda'

import { LoadingContainer } from 'peach/components'
import { StyledButton } from 'peach/components/Button/Button'
import Input from 'peach/components/Input'
import { useInternalTeamsCreate } from 'core/types'

import { ErrorComponent, FormActions, Title } from './Components'
import { Company } from './types'

type CreateTeamFormValues = {
  name: string
}

type CreateTeamFormProps = {
  company: Company
  updateCompany: (obj: Company) => void
  title: string
}

const CreateTeamForm: FC<CreateTeamFormProps> = ({
  company,
  updateCompany,
  title,
}) => {
  const form = useForm<CreateTeamFormValues>({
    values: {
      name: 'Peach Tier 2 Support',
    },
  })

  const {
    mutateAsync: createTeam,
    isPending,
    isError,
    error,
  } = useInternalTeamsCreate({
    companyId: company?.companyId,
  })

  const onCreate = async (values) => {
    const resp = await createTeam(values)

    if (resp?.status === 200 && !R.isEmpty(resp?.data)) {
      updateCompany({
        ...company,
        teams: [
          ...(company?.teams ?? []),
          {
            id: resp?.data?.id,
            name: resp?.data?.name,
            companyId: resp?.data?.companyId,
          },
        ],
      })
    }
  }

  return (
    <LoadingContainer loading={isPending}>
      <Title>{title}</Title>
      <form
        onSubmit={form.handleSubmit(async (values) => {
          try {
            await onCreate(values)
          } catch (e) {
            console.error('Error with create actions: ', e)
          }
        })}
      >
        <FormProvider {...form}>
          <Input
            label='Team name'
            required
            type='text'
            {...form.register('name')}
          />

          {isError &&
            !!error &&
            typeof error === 'object' &&
            'message' in error &&
            typeof error.message === 'string' && (
              <ErrorComponent>{error.message}</ErrorComponent>
            )}
          <FormActions>
            <StyledButton $primary type='submit'>
              Submit
            </StyledButton>
          </FormActions>
        </FormProvider>
      </form>
    </LoadingContainer>
  )
}

export default CreateTeamForm
